"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetState = void 0;
const react_1 = __importDefault(require("react"));
const useSetState = (initialState = {}) => {
    const [state, set] = react_1.default.useState(initialState);
    const setState = react_1.default.useCallback((patch) => {
        set((prevState) => Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch));
    }, [set]);
    return [state, setState];
};
exports.useSetState = useSetState;
